module.exports = __webpack_public_path__ + "54dc81e862b151a33814af4edf9ee12b.MP3";